import React, { memo } from 'react';
import NotImage from 'assets/images/image-default.svg';
import { Img } from './styled';

interface PropsTitle {
  className?: string;
  src: string;
  srcSet?: string;
  alt?: any;
  loading?: any;
}

const Image: React.FC<PropsTitle> = memo(({ className, src, srcSet, alt, loading }) => {
  const cleanUrl = src ? src.split('?')[0] : '';
  const computedSrcSet = srcSet || cleanUrl;

  return (
    <Img
      className={className}
      src={src}
      srcSet={computedSrcSet}
      alt={alt}
      loading={loading}
      onError={(event: any) => {
        event.target.onerror = null;
        event.target.srcset = '';
        event.target.src = NotImage as string;
      }}
    />
  );
});

export default Image;